import { elementOrComponentToElement, type ElementOrComponent } from '@/utilities/VueHelpers';
import { isArray } from '@vue/shared';
import { onMounted, onUnmounted } from 'vue';

/**
 * Checks if a mousedown event is outside of a given element and all its children
 * @param elements The element that we will check if the click is outside of
 * @param callback The callback function called when we click outside
 */
export const useClickOutside = (elements: ElementOrComponent | Array<ElementOrComponent>, callback: Function) => {
    const mouseDown = (payload: MouseEvent) => {
        if (!payload.target) {
            return;
        }

        if (!(payload.target instanceof Node)) {
            return;
        }

        const htmlElements = isArray(elements)
            ? elements.map((e) => elementOrComponentToElement(e))
            : [elementOrComponentToElement(elements)];

        // Exit if any of the elements are missing
        if (htmlElements.some((e) => !e)) {
            return;
        }

        // If we have clicked outside all the elements, trigger the callback
        if (!htmlElements.some((e) => e!.contains(payload.target as Node))) {
            callback();
        }
    };

    onMounted(() => window.addEventListener('mousedown', mouseDown));
    onUnmounted(() => window.removeEventListener('mousedown', mouseDown));
};
